import Windows from '../../windows';
import useMasterTab from '../hooks/useMasterTab';
import Sections from '../../sections';
import MasterTabConflictDialog from '../components/dialogs/MasterTabConflictDialog';
import ManualModeConflictDialog from '../components/dialogs/ManualModeConflictDialog';

const Home = () => {
  const { masterTabConflict, manualModeConflict } = useMasterTab();

  if (masterTabConflict) return <MasterTabConflictDialog />;
  if (manualModeConflict) return <ManualModeConflictDialog />;
  return (
    <>
      <Sections />
      <Windows />
    </>
  );
};

export default Home;
